// components/aside/CustomerLogin.jsx
'use client'
import Link from 'next/link'
import { useState, useEffect } from 'react'
import { useRouter } from 'next/navigation'
import { toast } from 'react-toastify'
import { loginWithCredentials } from '@/utils/auth'
import { closeModalUserlogin } from '@/utils/aside'

export default function CustomerLogin() {
  const router = useRouter()
  const [account, setAccount] = useState('')
  const [password, setPassword] = useState('')
  const [rememberMe, setRememberMe] = useState(false)

  const handleLogin = async () => {
    await loginWithCredentials({
      account,
      password,
      rememberMe,
      onSuccess: () => {
        document.getElementById('pageOverlay')?.click() // 關遮罩
        closeModalUserlogin()
        // 1. 先跳出成功提示
        toast.success('會員登入成功')
        // 2. 延遲 600 毫秒（0.6秒）後再執行網頁重刷，兼顧視覺體驗
        setTimeout(() => {
          window.location.reload()
        }, 300)
      },
      onError: () => alert('登入失敗'),
    })
  }

  useEffect(() => {
    const pageOverlay = document.getElementById('pageOverlay')
    if (!pageOverlay) return
    pageOverlay.addEventListener('click', closeModalUserlogin)
    return () => pageOverlay.removeEventListener('click', closeModalUserlogin)
  }, [])

  return (
    <div
      id="userAside"
      className="aside aside_right overflow-hidden customer-forms"
    >
      <div className="customer-forms__wrapper d-flex position-relative">
        <div className="customer__login">
          <div className="aside-header d-flex align-items-center">
            <h3 className="text-uppercase fs-6 mb-0">登入會員</h3>
            <button
              onClick={closeModalUserlogin}
              className="btn-close-lg js-close-aside ms-auto"
            />
          </div>

          <form onSubmit={(e) => e.preventDefault()} className="aside-content">
            <div className="form-floating mb-3">
              <input
                name="account"
                type="text"
                value={account}
                onChange={(e) => setAccount(e.target.value)}
                className="form-control form-control_gray"
                placeholder="帳號 / 手機 / Email *"
                required
              />
              <label>帳號 / 手機 / Email *</label>
            </div>

            <div className="pb-3" />

            <div className="form-label-fixed mb-3">
              <label className="form-label">密碼 *</label>
              <input
                name="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="form-control form-control_gray"
                placeholder
                required
              />
            </div>

            <div className="d-flex align-items-center mb-3 pb-2">
              <div className="form-check mb-0">
                <input
                  name="remember"
                  className="form-check-input form-check-input_fill"
                  type="checkbox"
                  checked={rememberMe}
                  onChange={(e) => setRememberMe(e.target.checked)}
                />
                <label className="form-check-label text-secondary">
                  記住我
                </label>
              </div>
              <Link href="/reset_password" className="btn-text ms-auto">
                忘記密碼?
              </Link>
            </div>

            <button
              className="btn btn-primary w-100 text-uppercase"
              type="submit"
              onClick={handleLogin}
            >
              登入
            </button>

            <div className="customer-option mt-4 text-center">
              <span className="text-secondary">還不是會員?</span>{' '}
              <Link
                href="/LoginOrRegister"
                className="btn-text js-show-register"
              >
                加入會員
              </Link>
            </div>
          </form>
        </div>

        {/* 右側註冊區保留原樣 */}
        <div className="customer__register">{/* ... */}</div>
      </div>
    </div>
  )
}
